import type { APPLICANT_ATTRIBUTION_BOTH_TYPE } from 'cpool-constants';
import { diff } from 'cpool-utils';

export interface LeafObject extends Record<string, unknown> {
    id: string;
    gehoertZuAntragsteller: APPLICANT_ATTRIBUTION_BOTH_TYPE;
}

function turnArrayIntoRecord(array: Array<LeafObject>) {
    const ids: Array<string> = [];
    const record = array.reduce((acc, curr) => {
        ids.push(curr.id);
        acc[curr.id] = curr;
        return acc;
    }, {} as Record<string, LeafObject>);
    return [ids, record] as const;
}

export function generateDiffItems(oldData: Array<LeafObject>, newData: Array<LeafObject>) {
    const removed: Array<LeafObject> = [];
    const added: Array<LeafObject> = [];
    const modified: Array<LeafObject> = [];
    // we turn the Arrays into a Record for faster access where the key is the id and the value is the object
    const [prevIds, prevRecord] = turnArrayIntoRecord(oldData);
    const [currIds, currRecord] = turnArrayIntoRecord(newData);

    // ids that are present in both prevIds and currIds - they might have been modified
    const keptIds: Array<string> = [];

    // iterate over the prevIds and check if they are included in the currIds, if not, we need to create a remove command
    prevIds.forEach((id) => {
        if (!currIds.includes(id)) {
            removed.push(prevRecord[id]);
        } else {
            keptIds.push(id);
        }
    });

    // iterate over the currIds and check if they are not included in the prevIds, if so, we need to create a add command
    currIds.forEach((id) => {
        if (!prevIds.includes(id)) {
            added.push(currRecord[id]);
        }
    });
    // compare the objects from the keptIds and see if they have been modified
    keptIds.forEach((id) => {
        const p = prevRecord[id];
        const c = currRecord[id];
        const difference = diff(p, c);
        if (typeof difference === 'object' && difference != null && Object.keys(difference).length > 0) {
            modified.push(c);
        }
    });

    return {
        added,
        modified,
        removed,
    };
}
